var map = {
	"./learn/locales/en.json": "336d",
	"./learn/locales/es.json": "f649",
	"./learn/locales/ja.json": "d97a",
	"./learn/locales/ko.json": "a435",
	"./planner/locales/en.json": "e4b7",
	"./planner/locales/es.json": "7732",
	"./planner/locales/ja.json": "1b8c",
	"./planner/locales/ko.json": "0f8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1640";